// extracted by mini-css-extract-plugin
export default {"cartPageContainer":"Cart_cartPageContainer__Gef5n","totalPrice":"Cart_totalPrice__vGX57","purchaseBtn":"Cart_purchaseBtn__UZpJM"};